/** "Ended 28 Jun" — null if the campaign end date doesn't parse. Shared by the finished cards. */
export const formatEndDate = (end: unknown): string | null => {
  if (typeof end !== "string") return null;
  const d = new Date(end);
  if (Number.isNaN(d.getTime())) return null;
  return new Intl.DateTimeFormat(undefined, {
    day: "numeric",
    month: "short",
  }).format(d);
};
